var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "album-header" }, [
    _c(
      "div",
      { staticClass: "album-header__title", on: { click: _vm.onClick } },
      [_c("svg-profile-header-back"), _vm._v(" "), _vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }